import { render } from "./LoadBalancing.vue?vue&type=template&id=0141dfc3&scoped=true"
import script from "./LoadBalancing.vue?vue&type=script&lang=js"
export * from "./LoadBalancing.vue?vue&type=script&lang=js"

import "./LoadBalancing.vue?vue&type=style&index=0&id=0141dfc3&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0141dfc3"]])

export default __exports__